import { render, staticRenderFns } from "./ProductsTree.vue?vue&type=template&id=eead684c&scoped=true&"
import script from "./ProductsTree.vue?vue&type=script&lang=js&"
export * from "./ProductsTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eead684c",
  null
  
)

export default component.exports